/* eslint-disable class-methods-use-this */

export default class Phase {

	offset = null;
	length = null;
	start = null;
	end = null;

	constructor(length) {
		this.length = length;
	}

	getBeatLength() {
		return this.length;
	}

	getPreludeLength() {
		throw new Error('Not implemented');
	}

	getPostludeLength() {
		throw new Error('Not implemented');
	}

	run() {
		throw new Error('Not implemented');
	}

}

class ConfigPhase extends Phase {
	constructor() {
		super(0);
	}

	getPreludeLength() {
		return 0;
	}

	getPostludeLength() {
		return null;
	}
}

Phase.Config = ConfigPhase;
